import { environment } from '../../../environments/environment';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subscription } from 'rxjs';
import { Admin } from 'src/app/shared/models/admin/admin';
import { AdminService } from 'src/app/shared/services/admin.service';
import { ClientService } from 'src/app/shared/services/client.service';
import { ParticipantService } from 'src/app/shared/services/participant.service';
import { DatatablesUtils } from "src/app/shared/datatable-utils";
import { Utils } from "src/app/shared/utils/utils";
import { TranslateService } from '@ngx-translate/core';

declare var jQuery: any;

@Component({
  selector: 'app-list-organizers',
  templateUrl: './list-organizers.component.html',
  styleUrls: ['./list-organizers.component.css']
})
export class ListOrganizersComponent implements OnInit {
  clients: any[] = [];
  busy: Subscription;
  dtOptions: any = {};
  perPage: number = 9;
  page: number = 1;
  dtElement: DataTableDirective;
  @ViewChild(DataTableDirective, { static: true })
  tri: string;
  order: string;
  ready: boolean = false;
  emailList: string[] = []; // Liste des e-mails disponibles
  selectedEmails: string[] = []; // E-mails sélectionnés par l'utilisateur
  selectedClients: string[] = [];
  emailSubject: string = ''; // Sujet de l'email
  emailBody: string = ''; // Corps du message
  currentClientEmail: string;
  isSending: boolean = false;
  isSendingMasse: boolean = false;
  availableBankers: any[] = [];
  selectedClient: any = null;
  selectedBankerId: number = null;
  availableSlots: any[] = [];
  selectedSlot: { bankerId: number; slot: any } | null = null;
  selectedInterval: number = null;
  isSubmitting: boolean = false;


  constructor(public clientService: ClientService, private router: Router, private translate: TranslateService) { }

  ngOnInit() {
    this.getallclient();
    this.openEmailModalMasse();
  }

  getallclient() {
    const that = this;
    this.dtOptions = {
      dom: "['<l>', Bfrtip']",
      buttons: ["colvis"],
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      aLengthMenu: [
        [5, 10, 25, 50, 100000],
        [5, 10, 25, 50, "All"],
      ],
      ajax: (dataTablesParameters: any, callback) => {
        const page = (dataTablesParameters.start / dataTablesParameters.length + 1);
        const perPage = dataTablesParameters.length;
        const search = dataTablesParameters.search.value;

        that.busy = that.clientService
          .getListClients(perPage, page, search)
          .subscribe(
            (data: any) => {
              console.log(data);
              this.clients = data.data;
              callback({
                recordsTotal: data.to,
                recordsFiltered: data.total,
                data: that.clients,
              });
            },
            (error) => { }
          );
      },
      columns: that.getColumns(),
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        jQuery(".action-btn", row).unbind("click");
        jQuery(".action-btn", row).bind("click", (event) => {
          const actionId = parseInt($(event.target).attr("action-id"), 0);
          this.goToAction(actionId, data);
        });
      },
    };
  }

  getColumns() {
    const columns = [
      { data: "company_name", visible: true, title: "Nom de l'Entreprise" },
      { data: "director_name", visible: true, title: "Nom du dirigeant" },
      { data: "phone", visible: true, title: "Téléphone" },
      { data: "email", visible: true, title: "Email" },
      /*{ data: "address", visible: true, title: "Adresse" },*/
      {
    data: "collaborateurs",
    visible: true,
    title: "Collaborateur",
    render: function(data: any[]) {
        if (!data || data.length === 0) return '<span class="text-muted">—</span>';

        const results = data.map((c: any) => {
            // Si pas de parent → c'est lui-même un collaborateur parent
            if (!c.parent_id) {
                return `<span class="badge badge-primary">${c.prenom ?? ''}</span>`;
            }
            // Sinon afficher son parent
            if (c.parent) {
                return `<span class="badge badge-primary">${c.parent.prenom ?? ''}</span>`;
            }
            return '';
        }).filter(v => v !== '');

        // Dédoublonner
        const unique = [...new Set(results)];
        return unique.length > 0 ? unique.join(' ') : '<span class="text-muted">—</span>';
    }
},
{
    data: "collaborateurs",
    visible: true,
    title: "Sous-collaborateur",
    render: function(data: any[]) {
        if (!data || data.length === 0) return '<span class="text-muted">—</span>';

        const results = data.map((c: any) => {
            // Si pas de parent → c'est un parent assigné directement, pas de sous-collab
            if (!c.parent_id) return '';
            return `<span class="badge badge-info">${c.prenom ?? ''}</span>`;
        }).filter(v => v !== '');

        return results.length > 0 ? results.join(' ') : '<span class="text-muted">—</span>';
    }
},
      {
        data: "actif",
        visible: true,
        title: "Statut",
        render: function(data) {
          return data
            ? '<span class="badge badge-success px-2 py-1">Actif</span>'
            : '<span class="badge badge-danger px-2 py-1">Passif</span>';
        }
      },
      { data: "activity_sector", visible: true, title: "Secteur d'activité" },
      { data: "siret", visible: true, title: "Siret" },
      /* { data: "idcc", visible: true, title: "IDCC" },
      { data: "code_naf", visible: true, title: "Code NAF" },
      { data: "creation_date", visible: true, title: "Date de création" },
      { data: "urssaf_identifiant", visible: true, title: "URSSAF Identifiant" },
      { data: "impots_identifiant", visible: true, title: "IMPOTS Identifiant" },
      { data: "retraite_identifiant", visible: true, title: "RETRAITE Identifiant" },
      { data: "prevoyance_identifiant", visible: true, title: "PREVOYANCE Identifiant" },
      { data: "mutuelle_identifiant", visible: true, title: "MUTUELLE Identifiant" },*/
      {
        data: "actions",
        visible: true,
        render: function () {
          return DatatablesUtils.renderActionsClientBtn();
        },
      },
    ];
    return columns;
  }

  private goToAction(actionId: number, data) {
    switch (actionId) {
      case 1: {
        this.router.navigate(["/admins/" + data.id + "/modify-client"]);
        break;
      }
      case 2: {
        this.removeClient(data.id);
        break;
      }
      case 3: { // Envoyer un Email
        this.openEmailModal(data.email); // Ouvrir la modale d'envoi d'email avec l'email du client
        break;
      }
      case 4: {
        this.clientService.hasAppointment(data.id).subscribe({
          next: (response) => {
            if (response.hasAppointment) {
              Utils.sweetAlert('error', 'Erreur', 'Ce client a déjà un rendez-vous.');
            } else {
              this.openAppointmentModal(data);
            }
          },
          error: (err) => {
            console.error("Erreur lors de la vérification du rendez-vous :", err);
            Utils.sweetAlert('error', 'Erreur', 'Erreur lors de la vérification du rendez-vous.');
          }
        });
        break;
      }

    }
  }

  openEmailModal(clientEmail: string) {
    // Fetch all client emails
    this.busy = this.clientService.getAllClientEmails().subscribe((response: any) => {

      this.emailList = response.map((emailObj: any) => emailObj.titre_mail);
      this.emailSubject = response.map((emailObj: any) => emailObj.object);
      this.emailBody = response.map((emailObj: any) => emailObj.template);
      this.selectedEmails = []; // Réinitialiser la sélection
      this.currentClientEmail = clientEmail; // Stocker l'e-mail du client courant
      this.showEmailModal(); // Afficher le modal
    });
  }

  openEmailModalMasse() {
    // Fetch all client emails
    this.busy = this.clientService.getAllClientEmails().subscribe((response: any) => {
      console.log(response);
      this.emailList = response.map((emailObj: any) => emailObj.titre_mail);
      this.emailSubject = response.map((emailObj: any) => emailObj.object);
      this.emailBody = response.map((emailObj: any) => emailObj.template);
      this.selectedEmails = []; // Réinitialiser la sélection
    });
  }


  showEmailModal() {
    // Ouvrir le modal
    jQuery('#emailModal').modal('show');
  }


  removeClient(client_id) {
    this.busy = this.clientService.removeClientById(client_id).subscribe(
      (data) => {

        Utils.sweetAlert('success', 'Succées', 'Suppression client avec succées');
        setTimeout(() => {
          window.location.reload();
        }, 2000); // 2000 milliseconds = 2 seconds

      }, error => {
        Utils.sweetAlert('error', 'Erreur', 'Erreur lors de la suppression');
      });
  }

  sendSelectedEmails() {
    if (this.isSending) return;

    // Vérifier si des emails sont sélectionnés
    if (this.selectedEmails.length === 0) {
      Utils.sweetAlert('error', 'Erreur', 'Veuillez sélectionner au moins un email.');
      return; // Sortir de la fonction si aucun email n'est sélectionné
    }

    this.isSending = true; // Démarrer l'envoi

    // Créer un tableau pour stocker les données des e-mails à envoyer
    const emailsToSend = this.selectedEmails.map(email => {
      // Trouver l'index de l'e-mail sélectionné dans emailList
      const emailIndex = this.emailList.indexOf(email);
      // Vérifier si l'index est valide
      if (emailIndex !== -1) {
        return {
          recipient: this.currentClientEmail, // Utiliser l'e-mail du client courant
          subject: this.emailSubject[emailIndex], // Objet de l'e-mail (l'email sélectionné)
          body: this.emailBody[emailIndex] // Corps de l'e-mail correspondant
        };
      }
    }).filter(Boolean); // Filtrer les valeurs undefined

    // Envoyer les e-mails
    this.busy = this.clientService.sendBulkEmails(emailsToSend).subscribe(response => {
      jQuery('#emailModal').modal('hide');
      Utils.sweetAlert('success', 'Succès', 'Mails envoyés avec succès');
    }, error => {
      console.error('Erreur lors de l\'envoi des e-mails:', error);
    }, () => {
      this.isSending = false; // Réinitialiser l'état après l'envoi
    });

  }



  toggleEmailSelection(email: string, isChecked: boolean) {
    if (isChecked) {
      this.selectedEmails.push(email);
    } else {
      this.selectedEmails = this.selectedEmails.filter(e => e !== email);
    }
  }

  toggleClientSelection(clientEmail: string, isChecked: boolean) {
    // Si la case est cochée, ajouter l'email du client à la liste selectedClients
    if (isChecked) {
      this.selectedClients.push(clientEmail);
    }
    // Sinon, retirer l'email du client de la liste selectedClients
    else {
      this.selectedClients = this.selectedClients.filter(email => email !== clientEmail);
    }
  }


  sendSelectedEmailsMasse() {
    // Vérifier s'il y a des emails et des utilisateurs sélectionnés
    console.log(this.selectedEmails);
    console.log(this.selectedClients);
    if (this.selectedEmails.length === 0 || this.selectedClients.length === 0) {
      Utils.sweetAlert('error', 'Erreur', 'Veuillez sélectionner au moins un modèle d\'email et un utilisateur.');
      return;
    }
    this.isSendingMasse = true;
    // Créer un tableau d'emails à envoyer
    const emailsToSend = [];

    // Parcourir chaque utilisateur sélectionné
    this.selectedClients.forEach(clientEmail => {
      // Pour chaque utilisateur, associer chaque modèle d'email sélectionné
      this.selectedEmails.forEach(emailTemplate => {
        const emailIndex = this.emailList.indexOf(emailTemplate); // Trouver l'index du template d'email
        if (emailIndex !== -1) {
          emailsToSend.push({
            recipient: clientEmail, // L'adresse email de l'utilisateur
            subject: this.emailSubject[emailIndex], // Le sujet de l'email (modèle sélectionné)
            body: this.emailBody[emailIndex] // Le corps du message correspondant au modèle sélectionné
          });
        }
      });
    });

    // Appeler le service pour envoyer les emails en masse
    this.busy = this.clientService.sendBulkEmails(emailsToSend).subscribe(response => {
      // Fermer le modal
      jQuery('#bulkEmailModal').modal('hide');
      // Message de succès
      Utils.sweetAlert('success', 'Succès', 'Les emails ont été envoyés avec succès.');
    }, error => {
      // Gestion des erreurs
      console.error('Erreur lors de l\'envoi des emails en masse :', error);
      Utils.sweetAlert('error', 'Erreur', 'Une erreur est survenue lors de l\'envoi des emails.');
    }, () => {
      this.isSendingMasse = false; // Réactiver les boutons une fois terminé
    });
  }

  toggleSelectAllClients(isChecked: boolean) {
    if (isChecked) {
      // Si la case est cochée, ajouter tous les emails des clients à la liste des sélectionnés
      this.selectedClients = this.clients.map(client => client.email);
    } else {
      // Si la case est décochée, vider la liste des clients sélectionnés
      this.selectedClients = [];
    }
  }

  toggleSelectAllEmails(isChecked: boolean) {
    if (isChecked) {
      // Si la case est cochée, ajouter tous les emails à la liste des sélectionnés
      this.selectedEmails = this.emailList.slice();  // Copier tous les modèles d'emails
    } else {
      // Si la case est décochée, vider la liste des emails sélectionnés
      this.selectedEmails = [];
    }
  }

  setInterval(minutes: number) {
    this.selectedInterval = +minutes;
  }

  selectSlot(bankerId: number, slot: any) {
    this.selectedSlot = { bankerId, slot };
    console.log(this.selectedSlot);
  }

  /*openAppointmentModal(clientData: any) {
    this.selectedClient = clientData;
    this.busy = this.clientService.getAvailableTimeSlots(clientData.id).subscribe(bankers => {
      this.availableBankers = bankers;
      console.log(this.availableBankers);
      jQuery('#appointmentModal').modal('show');
    }, error => {
      Utils.sweetAlert('error', 'Erreur', 'Impossible de charger les banquiers disponibles');
    });
  }*/

  openAppointmentModal(clientData: any) {
    this.selectedClient = clientData;

    this.busy = this.clientService.getAvailableTimeSlots(clientData.id).subscribe(bankers => {
      // Traitement pour grouper les créneaux par date pour chaque banquier
      this.availableBankers = bankers.map(banker => ({
        ...banker,
        groupedSlots: this.groupSlotsByDate(banker.availabilities)
      }));

      console.log(this.availableBankers); // Pour debug
      jQuery('#appointmentModal').modal('show');
    }, error => {
      Utils.sweetAlert('error', 'Erreur', 'Impossible de charger les banquiers disponibles');
    });
  }




  submitSelectedAppointment() {
    if (!this.selectedSlot) {
      Utils.sweetAlert('error', 'Erreur', 'Veuillez sélectionner un créneau');
      return;
    }
    this.isSubmitting = true;  // désactive le bouton
    const { bankerId, slot } = this.selectedSlot;

    const startTime = `${slot.date} ${slot.start_time}`;
    const end_time = `${slot.date} ${slot.end_time}`;
    const start = new Date(startTime);
    const end = new Date(start.getTime() + this.selectedInterval * 60000);
    const formattedEnd = end.toTimeString().split(' ')[0];

    const appointmentData = {
      client_id: this.selectedClient.id,
      banker_id: bankerId,
      start_time: startTime,
      end_time: end_time,
    };

    this.busy = this.clientService.createAppointment(appointmentData).subscribe({
      next: () => {
        Utils.sweetAlert('success', 'Succès', 'Rendez-vous pris avec succès');
        jQuery('#appointmentModal').modal('hide');
        this.selectedSlot = null;
        this.selectedInterval = null;
      },
      error: () => {
        Utils.sweetAlert('error', 'Erreur', 'Impossible de prendre ce rendez-vous');
      },
      complete: () => {
        this.isSubmitting = false;  // réactive le bouton
      }
    });
  }

  getUniqueDates(availabilities: any[]): string[] {
    const dates = availabilities.map(slot => slot.date);
    return Array.from(new Set(dates)).sort();
  }

  groupSlotsByDate(availabilities: any[]): { [date: string]: any[] } {
    const grouped: { [date: string]: any[] } = {};
    for (const slot of availabilities) {
      if (!grouped[slot.date]) {
        grouped[slot.date] = [];
      }
      grouped[slot.date].push(slot);
    }
    return grouped;
  }
}